import { render, staticRenderFns } from "./ViewPatientStoryText.vue?vue&type=template&id=d8df2fac&scoped=true"
import script from "./ViewPatientStoryText.vue?vue&type=script&lang=js"
export * from "./ViewPatientStoryText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8df2fac",
  null
  
)

export default component.exports